import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import MobileHeaderWithSidebar from "./Mobileheaderwithsidebar";
import AuthUser from "../services/AuthUser";


import UserHeader from "./User/UserHeader";

import { useAgentAuth } from "./Agent/AgentAuthContext";
import { useNavigate } from 'react-router-dom';





function Header() {

    const { setIsAuthenticated, setAgentData, isAuthenticated, agentData } = useAgentAuth();
    const location = useLocation();
    const navigate = useNavigate();

    // Define user-specific routes
    const userRoutes = [
        "/user_services",
        "/uploads",
        "/profile",
        "/agentprofile",
        "/agentservices",
        "/agentuploads",
        "/bookservice",
        "/ticket",
        "/ticket/*"

    ];

    // Check if the current route is a user route
  function isUserRoute(path) {
  return userRoutes.some(route => {
    if (route.endsWith('/*')) {
      const baseRoute = route.slice(0, -2);
      return path.startsWith(baseRoute);
    }
    return path === route;
  });
}

// Assuming you get location.pathname from React Router or window.location
const currentPath = location.pathname; 
const isUserPage = isUserRoute(currentPath);



    const { http, token, user, logout } = AuthUser();


    const logoutUser = () => {

        if (token != undefined) {
            logout();
        }
    }
    const [isMenuVisible, setIsMenuVisible] = useState(false);

    const closeMenu = () => {
        setIsMenuVisible(true); // Show the menu after clicking on a link
    };

    const handleMouseEnter = () => {
        setIsMenuVisible(false); // Hide the menu when hovering over the parent
    };



    const [agentToken, setAgentToken] = useState(localStorage.getItem("agent_token"));


    const [isDropdownOpen, setDropdownOpen] = useState(false);





    // Check login state on page load
    useEffect(() => {
        const atoken = localStorage.getItem("agent_token");
        const agent = localStorage.getItem("agent");

        setAgentData(agent ? JSON.parse(agent) : null); // ✅ Corrected JSON parsing

        setIsAuthenticated(!!atoken); // Convert token to boolean
    }, []);


    // Logout function
    const logoutAgent = () => {
        localStorage.removeItem("agent_token");
        localStorage.removeItem("agent");
        localStorage.removeItem("agentData");
        localStorage.removeItem("agentProfileImage");
        sessionStorage.removeItem('ticket_email');
        sessionStorage.removeItem('ticket_data');

        setIsAuthenticated(false); // Update UI without reload

        navigate('/');
    };



    useEffect(() => {
        const agent = JSON.parse(localStorage.getItem("agent"));

        if (agent?.email) {
            http.post('/check-agent-status', {
                email: agent.email
            }).then((response) => {
                const status = response.data?.status;

                if (status === 'paused') {
                    logoutAgent(); // This should log out the agent
                    alert("Your account has been paused. Please contact support.");
                }
            }).catch((error) => {
                console.error("Failed to check agent status", error);
            });
        }
    }, [location]); // Trigger on every route change




    const isAgent = localStorage.getItem("agent_token") !== null;

    const [profileImage, setProfileImage] = useState("assets/image/user.png"); // Default image

    useEffect(() => {
        const handleProfileImageUpdate = () => {
            const agentData = JSON.parse(localStorage.getItem('agent'));
            const userData = JSON.parse(localStorage.getItem('user'));

            if (isAuthenticated && agentData?.profile_picture) {
                setProfileImage(agentData.profile_picture);
            } else if (!isAuthenticated && userData?.profile_picture) {
                setProfileImage(userData.profile_picture);
            } else {
                setProfileImage("assets/image/user.png");
            }
        };

        // Listen for custom update event
        window.addEventListener('profileImageUpdated', handleProfileImageUpdate);

        // Call once on mount
        handleProfileImageUpdate();

        return () => {
            window.removeEventListener('profileImageUpdated', handleProfileImageUpdate);
        };
    }, [isAuthenticated]);


    return (
        <>
            {isUserPage ? (
                // User-Specific Navigation
                <UserHeader Logout={isAgent ? logoutAgent : logoutUser} />
            ) : (

                <div className="legal-251-main-header ">

                    
<div className="profile-section">
    <div className="main-menu profile-position">
        <div className="menu-wrap">
            <ul className="menu_list menu_list6">

                {/* Toggle between Agent Login & Agent Panel */}
                {token ? null : (
                    isAuthenticated ? (
                        <li
                            className="profile-menu"
                            onMouseEnter={() => setDropdownOpen(true)}
                            onMouseLeave={() => setDropdownOpen(false)}
                        >
                            <a className="profile-txt text-white" href="#">
                                Agent Panel
                            </a>

                            <ul className={`profile-dropdown ${isMenuVisible ? "open" : ""}`}>
                                <li>
                                    <Link
                                        className="user-pro d-flex align-items-center gap-2"
                                        to="/agentprofile"
                                    >
                                        <div style={{ flexShrink: 0 }}>
                                            <img
                                                src={profileImage}
                                                className="rounded-circle border shadow-sm"
                                                alt="Profile"
                                            />
                                        </div>
                                        <span className="d-block text-truncate" style={{ minWidth: 0 }}>
                                            <strong className="text-capitalize bold">Hello</strong>{" "}
                                            {agentData?.name}
                                            <br />
                                            <small className="text-muted">
                                                {agentData?.email}
                                            </small>
                                        </span>
                                    </Link>
                                </li>

                                <hr />

                                <li>
                                    <Link to="bookservice">Book Service</Link>
                                </li>

                                <li>
                                    <Link to="agentservices">Orders</Link>
                                </li>

                                <li>
                                    <Link to="agentuploads">KYC Upload</Link>
                                </li>

                                <hr />

                                <li>
                                    <span
                                        role="button"
                                        className="logout"
                                        onClick={logoutAgent}
                                    >
                                        Logout
                                    </span>
                                </li>
                            </ul>
                        </li>
                    ) : (
                        /* Login dropdown for User and Partner */
                       
<li
    className="profile-menu login-menu"
    onMouseEnter={() => setDropdownOpen(true)}
    onMouseLeave={() => setDropdownOpen(false)}
>
    <a
        className="profile-txt text-white"
        href="#"
        onClick={(e) => e.preventDefault()}
    >
        Login ▾
    </a>

    <ul className={`profile-dropdown ${isMenuVisible ? "open" : ""}`}>
        <li className="dropdown-heading">Login</li>
        <hr />

        <li>
            <Link to="/login" className="login-dropdown-link">
                <i className="fa fa-user" aria-hidden="true"></i>
                <span>User Login</span>
            </Link>
        </li>

        <li>
            <Link to="/agent-login" className="login-dropdown-link">
                <i className="fa fa-briefcase" aria-hidden="true"></i>
                <span>Partners Login</span>
            </Link>
        </li>
    </ul>
</li>

                    )
                )}

                {/* Existing User Profile */}
                {token ? (
                    <li
                        className="profile-menu"
                        onMouseEnter={handleMouseEnter}
                    >
                        <a className="profile-txt text-white" href="#">
                            My Profile
                        </a>

                        <ul className={`profile-dropdown ${isMenuVisible ? "open" : ""}`}>
                            <li>
                                <Link
                                    className="user-pro d-flex align-items-center gap-2"
                                    to="/profile"
                                >
                                    <div style={{ flexShrink: 0 }}>
                                        <img
                                            src={profileImage}
                                            className="rounded-circle border shadow-sm"
                                            alt="Profile"
                                        />
                                    </div>

                                    <span
                                        className="d-block text-truncate"
                                        style={{ minWidth: 0 }}
                                    >
                                        <strong className="text-capitalize bold">
                                            Hello
                                        </strong>{" "}
                                        {user.name}
                                        <br />
                                        <small className="text-muted">
                                            {user.email}
                                        </small>
                                    </span>
                                </Link>
                            </li>

                            <hr />

                            <li>
                                <Link to="/user_services">My Services</Link>
                            </li>

                            <li>
                                <Link to="/uploads">KYC Upload</Link>
                            </li>

                            <li>
                                <Link to="/ticket">Tickets</Link>
                            </li>

                            <hr />

                            <li>
                                <span
                                    role="button"
                                    className="logout"
                                    onClick={logoutUser}
                                >
                                    Logout
                                </span>
                            </li>
                        </ul>
                    </li>
                ) : null}

            </ul>
        </div>
    </div>

    {/* <AgentLoginModal setIsAuthenticated={setIsAuthenticated} setAgentData={setAgentData} /> */}
</div>


                    <div className="header10-top-area bg-sky">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-lg-6 col-6">
                                    <div className="header10-top-left header10-top">
                                        <a href="mailto:Demo@gmail.com">
                                            <img src="assets/img/icons/envelop.svg" alt="Email Icon" />
                                            accounts@Dm2Legal.com
                                        </a>
                                    </div>
                                </div>


                                {/* Second col-3 inside col-6 */}
                                <div className="col-lg-6 col-6">
    <div className="header10-top-right header10-top phone-numbers">
        <a href="tel:8370055955">
            <img src="assets/img/icons/whatsapp.svg" alt="WhatsApp Icon" />
            +91 8370055955
        </a>

        <a href="tel:8370055255">
            
            +91 8370055255
        </a>
    </div>
</div>


                            </div>
                        </div>
                    </div>




                    <header id="header" className="header header-area header-10 header-absolute d-none d-lg-block ">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="header-elements">
                                        <div className="header_menu_area">
                                            <div className="logo">

                                                <Link to="/">
                                                    <img src="assets/img/logo/header-logo10a.svg" alt="" />
                                                </Link>

                                            </div>
                                        </div>
                                        <div className="main-menu">
                                            <div className="menu-wrap">
                                                <ul className="menu_list menu_list6 ">
                                                    <li className="mega-menu-parrent" onMouseEnter={handleMouseEnter}>
                                                        <a href="#">Business Setup</a>
                                                        <ul className={`theme-mega-menu ${isMenuVisible ? 'open' : ''}`}>
                                                            <li className="mega-menu">
                                                                <div className="single-mega-menu">
                                                                    <h3 className="font-f-1">Business Setup</h3>
                                                                    <ul className="mega-sub-menu">
                                                                        <li>
                                                                            <Link to="/partnershipdeed" onClick={closeMenu}>
                                                                                <img src="assets/img/icons/nav-01.png" alt="" /> Partnership

                                                                            </Link>
                                                                        </li>

                                                                        <li>
                                                                            <Link to="/llpcompanyregistration" onClick={closeMenu}>
                                                                                <img src="assets/img/icons/nav-04.png" alt="Partnership RegistrationIcon" /> Limited Liability Partnership (LLP)
                                                                            </Link>
                                                                        </li>

                                                                        <li>
                                                                            <Link to="/opccompanyregistration" onClick={closeMenu}>
                                                                                <img src="assets/img/icons/nav-05.png" alt="Partnership RegistrationIcon" /> One Person Company (OPC)
                                                                            </Link>
                                                                        </li>

                                                                       





                                                                    </ul>
                                                                </div>
                                                                <div className="single-mega-menu" onClick={closeMenu}>
                                                                    {/* <h3 className="font-f-1">Compliance </h3> */}
                                                                    <ul className="mega-sub-menu">

                                                                         <li>
                                                                            <Link to="/pvtltdcompanyregistration" onClick={closeMenu}>
                                                                                <img src="assets/img/icons/nav-02.png" alt="Partnership RegistrationIcon" /> Pvt. Ltd. Company
                                                                            </Link>
                                                                        </li>

                                                                        <li>
                                                                            <Link to="/section8companyregistration" onClick={closeMenu}>
                                                                                <img src="assets/img/icons/nav-03.png" alt="Partnership RegistrationIcon" /> Section 8 Company
                                                                            </Link>
                                                                        </li>



                                                                    </ul>
                                                                </div>
                                                                <div className="single-mega-menu navimg">
                                                                    <img src="assets/img/images/consultancy.jpg" alt="" />
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </li>
                                                    <li className="mega-menu-parrent" onMouseEnter={handleMouseEnter}>
                                                        <a href="#">Change in Business</a>
                                                        <ul className={`theme-mega-menu ${isMenuVisible ? 'open' : ''}`}>
                                                            <li className="mega-menu">
                                                                <div className="single-mega-menu">
                                                                    <h3 className="font-f-1">Change in Business</h3>
                                                                    <ul className="mega-sub-menu">
                                                                        <li>
                                                                            <Link to="/dissolution-of-deeds" onClick={closeMenu}>
                                                                                <img src="assets/img/icons/cib (1).png" alt="" /> Partnership Dissolution

                                                                            </Link>
                                                                        </li>

                                                                        <li>
                                                                            <Link to="/address-amendment-llp" onClick={closeMenu}>
                                                                                <img src="assets/img/icons/cib (2).png" alt="Partnership RegistrationIcon" /> Address Amendment (LLP)
                                                                            </Link>
                                                                        </li>

                                                                        <li>
                                                                            <Link to="/address-amendment-company" onClick={closeMenu}>
                                                                                <img src="assets/img/icons/cib (3).png" alt="Partnership RegistrationIcon" /> Address Amendment (Company)
                                                                            </Link>
                                                                        </li>

                                                                        <li>
                                                                            <Link to="/address-amendment-outofstate-llp" onClick={closeMenu}>
                                                                                <img src="assets/img/icons/cib (4).png" alt="Partnership RegistrationIcon" /> Address Amendment out of state (LLP)
                                                                            </Link>
                                                                        </li>

                                                                        <li>
                                                                            <Link to="/address-amendment-outofstate-company" onClick={closeMenu}>
                                                                                <img src="assets/img/icons/cib (4).png" alt="Partnership RegistrationIcon" /> Address Amendment out of state (Company)
                                                                            </Link>
                                                                        </li>





                                                                    </ul>
                                                                </div>
                                                                <div className="single-mega-menu" onClick={closeMenu}>
                                                                    <h3 className="font-f-1" style={{ visibility: 'hidden' }}>c</h3>
                                                                    <ul className="mega-sub-menu">

                                                                        <li>
                                                                            <Link to="/add-director" onClick={closeMenu}>
                                                                                <img src="assets/img/icons/cib (5).png" alt="Partnership RegistrationIcon" /> Add Director (Company)
                                                                            </Link>
                                                                        </li>

                                                                        <li>
                                                                            <Link to="/add-partner" onClick={closeMenu}>
                                                                                <img src="assets/img/icons/cib (6).png" alt="Partnership Registration Icon" />Add Partner (Company)
                                                                            </Link>
                                                                        </li>
                                                                        <li>
                                                                            <Link to="/increase-capital-llp" onClick={closeMenu}>
                                                                                <img src="assets/img/icons/cib (7).png" alt="Increase Capital Icon" /> Increase Capital (LLP)

                                                                            </Link>
                                                                        </li>
                                                                     
                                                                      <li>
                                                                            <Link to="/increase-capital-company" onClick={closeMenu}>
                                                                                <img src="assets/img/icons/cib (11).png" alt="Increase Capital Icon" /> Increase Capital (Company)

                                                                            </Link>
                                                                        </li>



                                                                    </ul>
                                                                </div>
                                                                <div className="single-mega-menu" onClick={closeMenu}>
                                                                    <h3 className="font-f-1" style={{ visibility: 'hidden' }}>c</h3>
                                                                    <ul className="mega-sub-menu">

                                                                        <li>
                                                                            <Link to="/remove-director" onClick={closeMenu}>
                                                                                <img src="assets/img/icons/cib (9).png" alt="Partnership RegistrationIcon" /> Remove Director (Company)
                                                                            </Link>
                                                                        </li>

                                                                        <li>
                                                                            <Link to="/remove-partner" onClick={closeMenu}>
                                                                                <img src="assets/img/icons/cib (10).png" alt="Partnership Registration Icon" />Remove Partner (LLP)
                                                                            </Link>
                                                                        </li>
                                                                           <li>
                                                                            <Link to="/change-name-llp" onClick={closeMenu}>
                                                                                <img src="assets/img/icons/cib (8).png" alt="Change In Name Icon" />Change In Name (LLP)

                                                                            </Link>
                                                                        </li>
                                                                       
                                                                        <li>
                                                                            <Link to="/change-name-company" onClick={closeMenu}>
                                                                                <img src="assets/img/icons/cib (12).png" alt="Increase Capital Icon" />Change In Name (Company)

                                                                            </Link>
                                                                        </li>



                                                                    </ul>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </li>
                                                    <li className="mega-menu-parrent" onMouseEnter={handleMouseEnter}>
                                                        <a href="#">Business Registrations</a>
                                                        <ul className={`theme-mega-menu ${isMenuVisible ? 'open' : ''}`}>
                                                            <li className="mega-menu">
                                                                <div className="single-mega-menu">
                                                                    <h3 className="font-f-1"> Business Registrations</h3>
                                                                    <ul className="mega-sub-menu">

                                                                        <li>
                                                                            <Link to="/importexportlicenseiec" onClick={closeMenu}>
                                                                                <img src="assets/img/icons/nav-08.png" alt="Partnership RegistrationIcon" /> Import Export License (IEC)
                                                                            </Link>
                                                                        </li>

                                                                        <li>
                                                                            <Link to="/msmeregistration" onClick={closeMenu}>
                                                                                <img src="assets/img/icons/nav-09.png" alt="Partnership RegistrationIcon" /> MSME Registration
                                                                            </Link>
                                                                        </li>

                                                                        <li>
                                                                            <Link to="/gumastalicense" onClick={closeMenu}>
                                                                                <img src="assets/img/icons/nav-10.png" alt="Partnership RegistrationIcon" /> Shop Act License (Gumasta)

                                                                            </Link>
                                                                        </li>

                                                                    </ul>
                                                                </div>
                                                                <div className="single-mega-menu" >
                                                                    <h3 className="font-f-1" style={{ visibility: 'hidden' }}>c</h3>
                                                                    <ul className="mega-sub-menu">

                                                                        <li>
                                                                            <Link to="/trademarkregistration" onClick={closeMenu}>
                                                                                <img src="assets/img/icons/nav-11.png" alt="Partnership RegistrationIcon" /> Trade Mark Registration
                                                                            </Link>
                                                                        </li>

                                                                        <li>
                                                                            <Link to="/gstregistration" onClick={closeMenu}>
                                                                                <img src="assets/img/icons/nav-12.png" alt="Partnership RegistrationIcon" />GST Registration
                                                                            </Link>
                                                                        </li>

                                                                        <li>
                                                                            <Link to="/foodlicence" onClick={closeMenu}>
                                                                                <img src="assets/img/icons/nav-13.png" alt="Partnership RegistrationIcon" />FSSAI Registration

                                                                            </Link>
                                                                        </li>


                                                                    </ul>
                                                                </div>
                                                                <div className="single-mega-menu " onClick={closeMenu}>
                                                                    <h3 className="font-f-1" style={{ visibility: 'hidden' }}>c</h3>
                                                                    <ul className="mega-sub-menu">

                                                                        <li>
                                                                            <Link to="/trust-and-society" onClick={closeMenu}>
                                                                                <img src="assets/img/icons/nav-11.png" alt="Partnership RegistrationIcon" /> Trust/Society Registration
                                                                            </Link>
                                                                        </li>

                                                                        <li>
                                                                            <Link to="/pf-and-esic" onClick={closeMenu}>
                                                                                <img src="assets/img/icons/nav-12.png" alt="Partnership RegistrationIcon" />ESIC & PF Registration
                                                                            </Link>
                                                                        </li>

                                                                        <li>
                                                                            <Link to="/professionaltax" onClick={closeMenu}>
                                                                                <img src="assets/img/icons/nav-15.png" alt="Partnership RegistrationIcon" />Professional Tax Registration

                                                                            </Link>
                                                                        </li>


                                                                    </ul>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </li>
                                                    <li className="mega-menu-parrent" onMouseEnter={handleMouseEnter}>
                                                        <a href="#"> Filing and Compliance</a>
                                                        <ul className={`theme-mega-menu ${isMenuVisible ? 'open' : ''}`}>
                                                            <li className="mega-menu">
                                                                <div className="single-mega-menu">
                                                                    <h3 className="font-f-1"> Filing</h3>
                                                                    <ul className="mega-sub-menu">

                                                                        <li>
                                                                            <Link to="/gstreturnfiling" onClick={closeMenu}>
                                                                                <img src="assets/img/icons/nav-14.png" alt="Partnership RegistrationIcon" /> GST Return Filing
                                                                            </Link>
                                                                        </li>

                                                                        <li>
                                                                            <Link to="/itrfiling" onClick={closeMenu}>
                                                                                <img src="assets/img/icons/nav-15.png" alt="Partnership RegistrationIcon" /> ITR Filing
                                                                            </Link>
                                                                        </li>



                                                                        <li>
                                                                            <Link to="/tdsreturnfiling" onClick={closeMenu}>
                                                                                <img src="assets/img/icons/nav-16.png" alt="Partnership RegistrationIcon" /> TDS Return Filing
                                                                            </Link>
                                                                        </li>
                                                                        <li>
                                                                            <Link to="/pf-esic-return" onClick={closeMenu}>
                                                                                <img src="assets/img/icons/nav-16.png" alt="Partnership RegistrationIcon" /> PF & ESIC Return Filing
                                                                            </Link>
                                                                        </li>

                                                                    </ul>
                                                                </div>
                                                                <div className="single-mega-menu" onClick={closeMenu}>
                                                                    <h3 className="font-f-1">Compliance </h3>
                                                                    <ul className="mega-sub-menu">

                                                                        <li>
                                                                            <Link to="/annualcompliancellp" onClick={closeMenu}>
                                                                                <img src="assets/img/icons/nav-06.png" alt="Partnership RegistrationIcon" /> LLP Annual Compliance
                                                                            </Link>
                                                                        </li>

                                                                        <li>
                                                                            <Link to="/annualcompliancepvtltd" onClick={closeMenu}>
                                                                                <img src="assets/img/icons/nav-07.png" alt="Partnership Registration Icon" /> Company Annual Compliance
                                                                            </Link>
                                                                        </li>
                                                                        



                                                                    </ul>
                                                                </div>
                                                                <div className="single-mega-menu navimg">
                                                                    <img className="navimg" src="assets/img/images/accounting.jpg" alt="" />
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </li>
                                                    
                                                      <li className="mega-menu-parrent" onMouseEnter={handleMouseEnter}>
                                                        <a href="#">Other</a>
                                                        <ul className={`theme-mega-menu ${isMenuVisible ? 'open' : ''}`}>
                                                            <li className="mega-menu">
                                                                 <div className="single-mega-menu">
                                                                    <h3 className="font-f-1"> Accounting </h3>
                                                                    <ul className="mega-sub-menu">
                                                                        <li>
                                                                            <Link to="/onlineaccounting" onClick={closeMenu}>
                                                                                <img src="assets/img/icons/nav-17.png" alt="Partnership RegistrationIcon" /> Online Accounting
                                                                            </Link>
                                                                        </li>

                                                                        <li>
                                                                            <Link to="/balancesheet" onClick={closeMenu}>
                                                                                <img src="assets/img/icons/nav-15.png" alt="Partnership RegistrationIcon" /> Balance Sheet Preparation & P&L
                                                                            </Link>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                                <div className="single-mega-menu" >
                                                                    <h3 className="font-f-1"> CMA Report </h3>
                                                                    <li>
                                                                            <Link to="/cmareport" onClick={closeMenu}>
                                                                                <img src="assets/img/icons/nav-10.png" alt="CMA Report Icon" /> Project Report (CMA)

                                                                            </Link>
                                                                        </li>
                                                                </div>
                                                                <div className="single-mega-menu navimg" >
                                                                    <img src="assets/img/images/accounting.jpg" alt="" />
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </li>


                                                    <li className="mega-menu-parrent" onMouseEnter={handleMouseEnter}>
                                                        <a href="#">Legal Services</a>
                                                        <ul className={`theme-mega-menu ${isMenuVisible ? 'open' : ''}`}>
                                                            <li className="mega-menu">
                                                                <div className="single-mega-menu">
                                                                    <h3 className="font-f-1">Legal Services</h3>
                                                                    <ul className="mega-sub-menu">
                                                                        <li>
                                                                            <Link to="/legalnoticereply" onClick={closeMenu}>
                                                                                <img src="assets/img/icons/nav-18.png" alt="Partnership RegistrationIcon" /> Legal Notice Reply
                                                                            </Link>
                                                                        </li>
                                                                        <li>
                                                                            <Link to="/legalclaimhelp" onClick={closeMenu}>
                                                                                <img src="assets/img/icons/nav-19.png" alt="Partnership RegistrationIcon" />Legal Advice
                                                                            </Link>
                                                                        </li>
                                                                         <li>
                                                                            <Link to="/legalnotice" onClick={closeMenu}>
                                                                                <img src="assets/img/icons/nav-20.png" alt="Partnership RegistrationIcon" /> Legal Notice Drafting
                                                                            </Link>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                                <div className="single-mega-menu" >
                                                                    <h3 className="font-f-1"> Drafting </h3>
                                                                    <ul className="mega-sub-menu">
                                                                        <li>
                                                                            <Link to="/drafting"><img src="assets/img/icons/cib (12).png" alt="Drafting Icon" /> Agreement Drafting
                                                                        </Link>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                                <div className="single-mega-menu navimg" >
                                                                    <img src="assets/img/images/accounting.jpg" alt="" />
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </li>

                                                    <li><Link to="/aboutcompany">
                                                        About Company
                                                    </Link>
                                                    </li>




                                                </ul>
                                            </div>
                                        </div>
                                        <div className="header10-side-button">
                                            <Link to="/contactus" className="new-btn7">
                                                <span><img src="assets/img/icons/new-btn7-icon.svg" alt="" /></span> Free Consultation
                                            </Link>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </header>



                    <div className="sidesocialicon">
                        <a href="#" target="_blank"><img src="assets/img/Socialicons/fb.png" className="socialicon" /></a>
                        <div className="space10"></div>
                        <a href="#" target="_blank"><img src="assets/img/Socialicons/insta.png" className="socialicon" /></a>
                        <div className="space10"></div>
                        <a href="#" target="_blank"><img src="assets/img/Socialicons/linkedin.png" className="socialicon" /></a>
                        <div className="space10"></div>
                        <a href="#" target="_blank"><img src="assets/img/Socialicons/twitter.png" className="socialicon" /></a>
                    </div>

                    <MobileHeaderWithSidebar />
                </div>

            )}
        </>
    );
}

export default Header;
